
import PageHeader from "../components/PageHeader";
import {
    FaFileContract,
    FaUserCheck,
    FaCreditCard,
    FaBan,
    FaExclamationTriangle,
    FaGavel,
    FaPhoneAlt
} from "react-icons/fa";
import { Helmet } from "react-helmet-async";

export default function TermsConditions() {
    return (
        <>
            <Helmet>
                {/* Basic SEO */}
                <title>Terms & Conditions | UAE Dubai Hotels</title>

                <meta
                    name="description"
                    content="Read the Terms & Conditions of UAE Dubai Hotels to understand our hotel booking policies, payment terms, cancellations, refunds, user responsibilities, and website usage guidelines."
                />

                <meta
                    name="keywords"
                    content="Terms and Conditions, UAE Dubai Hotels, hotel booking terms UAE, cancellation policy, refund policy, booking conditions, website terms, Dubai hotels"
                />

                <meta name="robots" content="index, follow" />
                <meta name="author" content="UAE Dubai Hotels" />

                {/* Canonical */}
                <link
                    rel="canonical"
                    href="https://uaedubaihotels.com/terms-conditions"
                />

                {/* Open Graph */}
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="UAE Dubai Hotels" />
                <meta property="og.locale" content="en_US" />

                <meta
                    property="og:title"
                    content="Terms & Conditions | UAE Dubai Hotels"
                />

                <meta
                    property="og:description"
                    content="Review the terms and conditions related to hotel bookings, payments, cancellations, refunds, and the use of UAE Dubai Hotels services."
                />

                <meta
                    property="og:url"
                    content="https://uaedubaihotels.com/terms-conditions"
                />

                <meta
                    property="og:image"
                    content="https://uaedubaihotels.com/images/default-og.png"
                />

                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Terms & Conditions | UAE Dubai Hotels"
                />

                <meta
                    name="twitter:description"
                    content="Read the terms governing hotel reservations, payments, cancellations, refunds, and website usage at UAE Dubai Hotels."
                />

                <meta
                    name="twitter:image"
                    content="https://uaedubaihotels.com/images/default-og.png"
                />
            </Helmet>

            <div className="
    w-full
    bg-[#FCFAF5]
    dark:bg-gray-950
">

                <PageHeader
                    title="Terms & Conditions"
                    subtitle="Please review the terms governing your use of UAEDiscountedHotels travel and booking services."
                />

                <div className="
    max-w-6xl
    mx-auto
    px-6
    py-20
    grid
    md:grid-cols-4
    gap-10
">

                    {/* SIDEBAR */}
                    <div className="md:col-span-1">

                        <div
                            className="
sticky
top-24

bg-white
dark:bg-gray-900

border
border-[#DDD2BA]
dark:border-gray-800

rounded-[35px]

p-6

shadow-xl
"
                        >
                            <h3 className="
font-semibold
text-[#0F766E]
dark:text-[#B89442]
mb-4
">
                                Quick Links
                            </h3>

                            <div className="space-y-3">
                                {[
                                    "Introduction",
                                    "User Responsibilities",
                                    "Bookings & Payments",
                                    "Cancellations",
                                    "Prohibited Activities",
                                    "Liability",
                                    "Changes to Terms",
                                    "Governing Law",
                                ].map((item, i) => (
                                    <a
                                        key={i}
                                        href={`#section-${i}`}
                                        className="
                      block text-sm
                      text-gray-600 dark:text-gray-400
                      hover:text-[#B89442]
dark:hover:text-[#B89442]
                      transition
                    "
                                    >
                                        {item}
                                    </a>
                                ))}
                            </div>
                        </div>

                    </div>

                    {/* CONTENT */}
                    <div className="md:col-span-3">

                        <div
                            className="
                bg-white
dark:bg-gray-900

border
border-[#DDD2BA]
dark:border-gray-800

rounded-[40px]

p-8
md:p-10
              "
                        >

                            <Section
                                id="section-0"
                                icon={<FaFileContract />}
                                title="Introduction"
                                text="By accessing and using UAEDiscountedHotels, you agree to comply with these Terms & Conditions. Please review them carefully before making any reservation or booking."
                            />

                            <Section
                                id="section-1"
                                icon={<FaUserCheck />}
                                title="User Responsibilities"
                                list={[
                                    "Provide accurate personal and booking information",
                                    "Maintain confidentiality of your account credentials",
                                    "Use our services only for lawful purposes",
                                ]}
                            />

                            <Section
                                id="section-2"
                                icon={<FaCreditCard />}
                                title="Bookings & Payments"
                                text="All reservations are subject to availability. Payments must be completed through approved secure payment methods. Prices and availability may change without prior notice."
                            />

                            <Section
                                id="section-3"
                                icon={<FaBan />}
                                title="Cancellations & Refunds"
                                text="Cancellation and refund policies differ by hotel, airline, tour operator, or service provider. Customers should review applicable policies before confirming bookings."
                            />

                            <Section
                                id="section-4"
                                icon={<FaExclamationTriangle />}
                                title="Prohibited Activities"
                                list={[
                                    "Fraudulent transactions or bookings",
                                    "Unauthorized access to systems",
                                    "Violation of local or international laws",
                                    "Misuse of travel services or website content",
                                ]}
                            />

                            <Section
                                id="section-5"
                                icon={<FaGavel />}
                                title="Limitation of Liability"
                                text="UAEDiscountedHotels acts as an intermediary for travel services. We are not responsible for delays, cancellations, service interruptions, or losses caused by third-party providers."
                            />

                            <Section
                                id="section-6"
                                icon={<FaFileContract />}
                                title="Changes to Terms"
                                text="We reserve the right to modify these Terms & Conditions at any time. Continued use of our services constitutes acceptance of the revised terms."
                            />

                            <Section
                                id="section-7"
                                icon={<FaGavel />}
                                title="Governing Law"
                                text="These Terms & Conditions shall be governed by applicable laws and regulations. Any disputes shall be subject to the jurisdiction of the relevant courts and authorities."
                            />

                            {/* CTA */}
                            <div
                                className="
rounded-[35px]

bg-[#0F766E]

text-white

p-8

text-center

shadow-xl
"
                            >
                                <h3 className="text-2xl font-semibold mb-3">
                                    Need clarification?
                                </h3>

                                <p className="
mb-5
text-white/80
">
                                    Contact our support team for assistance regarding our terms and policies.
                                </p>

                                <a
                                    href="tel:+971501234567"
                                    className="
inline-flex
items-center
gap-2

bg-[#B89442]

text-white

px-6
py-3

rounded-full

font-semibold

hover:bg-white
hover:text-[#0F766E]

hover:scale-105

transition
"
                                >
                                    <FaPhoneAlt />
                                    Call Support
                                </a>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

function Section({ id, icon, title, text, list }) {
    return (
        <div
            id={id}
            className="
        scroll-mt-28
        mb-10
        last:mb-0
    "
        >
            <div className="flex items-center gap-3 mb-4">

                <div
                    className="
w-12
h-12

rounded-2xl

flex
items-center
justify-center

bg-[#0F766E]

text-white

shadow-md
"
                >
                    {icon}
                </div>

                <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                    {title}
                </h2>
            </div>

            {text && (
                <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                    {text}
                </p>
            )}

            {list && (
                <ul className="list-disc pl-5 text-gray-600 dark:text-gray-400 space-y-2">
                    {list.map((item, i) => (
                        <li key={i}>{item}</li>
                    ))}
                </ul>
            )}
        </div>
    );
}